
import './App.css';
import React from 'react';
import MapWithMarkers from './MapWithMarkers';


import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously, GoogleAuthProvider, signInWithPopup, OAuthProvider, getRedirectResult, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";


import { getAnalytics } from "firebase/analytics";
import CountDown from './CountDown';

const firebaseConfig = {
  apiKey: "AIzaSyD6JI3aULzTexBoYo_PJu4qwFWpkzQ7VwQ",
  authDomain: "swami-birthday-98.firebaseapp.com",
  projectId: "swami-birthday-98",
  storageBucket: "swami-birthday-98.appspot.com",
  messagingSenderId: "976263405645",
  appId: "1:976263405645:web:2328ce0d1665f53222bc04",
  measurementId: "G-ENC55T33K8",
  databaseURL: "https://swami-birthday-98-default-rtdb.asia-southeast1.firebasedatabase.app"
}

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const rdb = getDatabase(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);


export default class App extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      user: false,
      hidecurtain: false
    }
  }

  signOut = async () => {
    signOut(auth).then(() => {
      this.setState({
        user: null
      })
    }).catch((error) => {
      console.log(analytics);
      // An error happened.
    });
  }

  signIn = async(mode = '') => {
    let user, provider;
    try{
      switch(mode){
        case 'yahoo':
          provider = new OAuthProvider('yahoo.com');
          user = await signInWithPopup(auth, provider);
          console.log(user);
          user = user.user;
        break;
        case 'microsoft':
          provider = new OAuthProvider('microsoft.com');
          user = await signInWithPopup(auth, provider);
          console.log(user);
          user = user.user;
        break;
        case 'google':
          provider = new GoogleAuthProvider();
          user = provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
          user = await signInWithPopup(auth, provider);
          console.log(user);
          user = user.user;
        break;
        case 'anonymous':
          user = await signInAnonymously(auth);
          user = user.user
        break;
        default:
          user = auth.currentUser;
          
        break;
      };
      this.setState({
        user: user
      }, () => {
       // console.log(this.state.user);
      })
    }catch(ex){
      console.log(ex.code, ex.message);
    }
    
  }

  async componentDidMount(){
    this.openCurtains();
    await getRedirectResult(auth);
    await this.signIn();
    setTimeout(()=>{
      this.setState({
        hidecurtain:true
      })
    }, 3600)
    
  }

  openCurtains = () => {
    var curtain = document.getElementById("curtain");
                curtain.className = "open";
                
                var scene = document.getElementById("scene");
                scene.className = "expand";
                this.setState({
                  curtainOpen: true
                })
  }

  render(){
    return (
      <div className="App">
        {
          !this.state.hidecurtain &&
          <div id='scene'>
          <div id='curtain'>
            <div  className='contents'>
              <div style={{maxWidth:"400px", background:"#fff", padding:"5px", position: "relative"}}>
              <img alt='' onClick={()=>{
                this.setState({
                  hidecurtain: true
                })
              }} src='/banner.jpg' style={{maxWidth:"100%", cursor:"pointer", position:"relative"}} />
              
              </div>
              
            </div>
            <div className='ground'></div>
            <div className='left'></div>
            <div className='right'></div>
          </div>
        </div>
        }
        <header >
          <div className='logo-container'>

          <div className='logo-img d-none'>
          <img style={{width:"45px"}} src="https://www.sssmediacentre.org/sssct.png" alt='' />
          <div className='logo-tooltip w-80'  >
            <a href='https://www.srisathyasai.org' target='_blank'  rel="noopener noreferrer">
            Sri Sathya Sai Central Trust
            </a>
          </div>
          </div>
          <div className='countdown-container' style={{padding:"5px 10px"}}>
         
          <div className='countdown' style={{ padding:"0px 10px 10px 10px"}}>
          
          <CountDown endAt={'2023-11-23 00:00:00'} />
          
          </div>
        
         
         
          </div>
          <div className='countdown-container' style={{padding:"5px 10px", 
          position: "fixed",
          bottom: "90px",
          right: "0",
          width: "100%"}}>
            
         
          </div>
          <div  className='logo-img d-none'>
          <img style={{width:"45px"}} src="https://www.sssmediacentre.org/755f75139b00a808ae072efc6cdd7ae8.png" alt='' />
          <div className='logo-tooltip w-80' >
            <a href='https://www.sssmediacentre.org' target='_blank'  rel="noopener noreferrer">
            Sri Sathya Sai Media Centre
            </a>
          </div>
          </div>

          </div>
          </header>
        {
          this.state.user !== false &&
          <MapWithMarkers rdb={rdb} db={db} signIn={this.signIn} signOut={this.signOut} state={this.state} />
        }
      </div>
    );
  }
}
